<template>
  <div>
    <open-fund-header/>
    <div class="r-text-intro frame"> החלק הכי קשה, זה להתחיל</div>
    <div class="r-text-headline-paragraph frame">
      <div>אבל זה מתחיל בקטנה,</div>
      <div>באמת בקטנה.</div>
    </div>
    <div class="r-text-headline-paragraph frame">
      ב-100, 200 שקל בחודש.
    </div>
    <div class="r-text-headline-paragraph frame">
      <div>וככה, מחודש לחודש,</div>
      <div>יש כסף בצד שגדל <span class="r-text-bold">בשבילך.</span> </div>
    </div>
    <default-button label="מה כבר יצא לי מ-200 ₪ בחודש?" @click="next" class="frame"/>
  </div>
</template>

<script>
import anime from 'animejs/lib/anime.es';
import TrackedPage from '@/mixins/TrackedPage';
import DefaultButton from '@/components/styled/DefaultButton';
import OpenFundHeader from '@/components/meitav-dash/OpenFundHeader';

export default {
  name: 'JustStart',
  components: { OpenFundHeader, DefaultButton },
  mixins: [TrackedPage],
  mounted() {
    anime({ targets: '.frame', opacity: 1, duration: 5000, delay: anime.stagger(2000) });
  },
  methods: {
    next() {
      this.$router.push('projection');
    },
  },
};
</script>

<style lang="scss" scoped>
.frame {
  opacity: 0;
}
</style>
